import React, { useState, useEffect } from "react";
import HeroHomeAttendant from "../../component/Hero/HeroHomeAttendant";
import booksurgeryimg1 from "../../assets/booksurgeryimg1.png";
import Breadcrumb from "../../component/breadcrumb/breadcrumb";
import { Container, Row, Col } from "react-bootstrap";
import Hospitalsliders from "../Hospitaldetails/hospitalsliders";
import BookTrick from "./booktricks";
import MedicalStaffSurgery from "./medicalstaffslider";
import { useNavigate } from "react-router-dom";
import "./booksurgery.css";
import Mobile from "../../component/mobile/mobile";
import { SurgeryList } from "../../env/action";

const BookSurgery = () => {
  const navigate = useNavigate();
  const [surgeryList, setSurgeryList] = useState([]);

  useEffect(() => {
    SurgeryList((res) => {
      if (res?.status === 1) {
        setSurgeryList(res.data);
      } else {
        alert("No data found");
      }
    });
  }, []);

  const handleClick = (item) => {
   navigate(`/hospitals/${item.id}`);

  };

  return (
    <>
      <div className="booksurgery">
        <div style={{ backgroundColor: "#F9F9F9" }} className="pb-3">
          <Breadcrumb
            breadcrumbTitle="Surgery"
            breadcrumbNav={[{ navText: "Home", path: "/" }]}
          />

          <HeroHomeAttendant img={booksurgeryimg1} />

          <Container>
            <p className="fs-3 fw-bolder text-center mt-4 text-dark">Book a Surgery</p>

            {/* Surgery Grid */}
            <Row className="justify-content-center">
              {surgeryList.map((item) => (
                <Col
                  key={item.id}
                  lg={2}
                  md={4}
                  sm={6}
                  xs={12}
                  className="d-flex border p-3 align-items-center gy-3 colfocus rounded-3"
                  onClick={() => handleClick(item)}
                >
                  <img
                    src={item.icon}
                    className="colfocus-img"
                    style={{ width: "35px" }}
                    alt=""
                  />
                  <p className="ms-4 mb-0 colfocus-text">{item.surgery_name}</p>
                </Col>
              ))}
            </Row>

            {/* <p className="fs-2 fw-bolder mt-3 text-dark">Hospital Appointment</p>
            <p className="text-dark">
              Enjoy smooth hospitalization and surgical planning...
            </p> */}
{/* 
            <MedicalStaffSurgery /> */}

            {/* <p className="fs-2 fw-bolder mt-3 text-dark">Industry Leading Hospital Partners</p>
            <Hospitalsliders /> */}
          </Container>
        </div>
      </div>

      <BookTrick />
      <Mobile />
    </>
  );
};

export default BookSurgery;
